<template>
  <div class="parameters-print-table">
    <physical-chemical-flex-table-title
      class="mb-1"
      :norm="rule"
      :show-custom-name-below="false"
    />
    <s-table
      small
      bordered
      fixed
      :items="items"
      :fields="fields"
    >
      <template #cell(text)="data">
        <div class="parameters-print-table__display-print">
          {{ $t(data.value, data.item.textParams) }}
        </div>
      </template>
      <template #cell(value)="data">
        <div class="parameters-print-table__display-print">
          {{ getFieldValue(data.item.key) }}
        </div>
      </template>
      <template #cell(parameter)="data">
        <div class="parameters-print-table__display-print">
          {{ getTableReport(rule.rules, data.item.key) }}
        </div>
      </template>
    </s-table>
  </div>
</template>

<script>
import PhysicalChemicalFlexTableTitle from '@/domain/components/installation/engineering/physicalChemical/PhysicalChemicalFlexTableTitle';
import GeneralService from '@/domain/services/installation/engineering/physicalChemical/generalTab';

export default {
  name: 'ParametersPrintTable',
  components: { PhysicalChemicalFlexTableTitle },
  props: {
    rule: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    table: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fields() {
      return [
        {
          key: 'text',
          label: this.$t('engineering.reports.test'),
          thClass: 'parameters-print-table__test',
        },
        {
          key: 'value',
          label: this.$t('engineering.physical-chemical.print.sample-value'),
        },
        {
          key: 'parameter',
          label: this.$t('engineering.physical-chemical.print.parameter'),
          thClass: 'parameters-print-table__parameter',
        },
      ];
    },
  },
  methods: {
    getTableReport(values, field) {
      const value = values[0][field];
      if (value) {
        return this.getFieldValue(field, value);
      }
      return '--';
    },
    getFieldValue(field, parameterValue) {
      const value = parameterValue || this.table.tests[field];
      const valueType = typeof value;
      const processedValue = {
        number: this.$n(value),
        boolean: this.getBooleanFieldsLabel(value, field),
      };
      return processedValue[valueType] || value || '--';
    },
    getBooleanFieldsLabel(value, field) {
      const translationResolver = GeneralService.sampleListRenderingHelpers
        .valueTranslationPathResolvers[field];
      if (translationResolver) {
        return this.$t(translationResolver(value));
      }
      return value;
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  ::v-deep
    .parameters-print-table
      &__test
        width: 475px
      &__parameter
        text-align: center !important
    .flex-table-title
      font-size: 1.2rem
    .physical-chemical-title
      text-align: left
    tbody tr td:last-child
      text-align: center !important
    th, td
      border: 1px solid $color-gray-intermediary
  @media print
    .parameters-print-table
      &__display-print
        display: block
        float: none

</style>
